export const companyInfo = {
  tr: {
    name: 'DEMART',
    fullName: 'Demart Mühendislik Sanayi Ticaret Limited Şirketi',
    tagline: 'THE ART OF DESIGN-ENGINEERING MAINTENANCE',
    subtitle: 'Sofis Türkiye & Azerbaycan Resmi Distribütörü',
    phone: '+90 216 401 10 50',
    email: 'info@demart.com.tr',
    address: {
      street: 'Velibaba Mah. Ertuğrul Gazi Cad. No 82/1, 34896 Pendik, İstanbul / TÜRKİYE',
      district: 'Pendik',
      postalCode: '34896',
      city: 'İstanbul',
      country: 'TÜRKİYE'
    },
    fullAddress: 'Velibaba Mah. Ertuğrul Gazi Cad. No 82/1, 34896 Pendik, İstanbul / TÜRKİYE',
    callNow: 'Bizi Arayın'
  },
  en: {
    name: 'DEMART',
    fullName: 'Demart Mühendislik Sanayi Ticaret Limited Şirketi',
    tagline: 'THE ART OF DESIGN-ENGINEERING MAINTENANCE',
    subtitle: 'Official Sofis Distributor in Turkiye & Azerbaijan',
    phone: '+90 216 401 10 50',
    email: 'info@demart.com.tr',
    address: {
      street: 'Velibaba Mah. Ertuğrul Gazi Cad. No 82/1, 34896 Pendik, Istanbul / TURKEY',
      district: 'Pendik',
      postalCode: '34896',
      city: 'Istanbul',
      country: 'TURKEY'
    },
    fullAddress: 'Velibaba Mah. Ertuğrul Gazi Cad. No 82/1, 34896 Pendik, Istanbul / TURKEY',
    callNow: 'Call Now'
  },
  az: {
    name: 'DEMART',
    fullName: 'Demart Mühendislik Sanayi Ticaret Limited Şirketi',
    tagline: 'THE ART OF DESIGN-ENGINEERING MAINTENANCE',
    subtitle: 'Sofis-in Türkiyə & Azərbaycan rəsmi distribütoru',
    phone: '+90 216 401 10 50',
    email: 'info@demart.com.tr',
    address: {
      street: 'Velibaba Mah. Ertuğrul Gazi Cad. No 82/1, 34896 Pendik, İstanbul / TÜRKİYƏ',
      district: 'Pendik',
      postalCode: '34896',
      city: 'İstanbul',
      country: 'TÜRKİYƏ'
    },
    fullAddress: 'Velibaba Mah. Ertuğrul Gazi Cad. No 82/1, 34896 Pendik, İstanbul / TÜRKİYƏ',
    callNow: 'İndi Zəng Edin'
  }
};
